import { getLocalTimeZone, today } from '@internationalized/date'

import type { TSimulacaoParcela } from '@/domain/simulador/gerenciador-entradas-base'

export class CriadorParcelasBase {
  static readonly criar = (dataInicio = today(getLocalTimeZone()).toString(), valor = 0): TSimulacaoParcela => {
    return { data: dataInicio, valor }
  }
}
